import { Card, Flex, Grid, Skeleton } from '@mantine/core';

export default function CardLoaderSkeleton({
  cardContentRows = 5,
  cardActionsRows = 1
}: {
  cardContentRows?: number;
  cardActionsRows?: number;
}) {
  return (
    <>
      <Card>
        <Card.Section inheritPadding withBorder py="xs">
          <Grid align="center">
            <Grid.Col span={12}>
              <Skeleton height={8} mt={6} radius="xl" />
            </Grid.Col>
          </Grid>
        </Card.Section>
        <Card.Section inheritPadding withBorder py="xs">
          <Grid gutter={0}>
            {Array.from({ length: cardContentRows }).map((_, idx) => {
              return (
                <Grid.Col span={12} key={`${idx}-${cardContentRows}`}>
                  <Skeleton height={8} mt={6} radius="xl" />
                </Grid.Col>
              );
            })}
          </Grid>
        </Card.Section>
        <Card.Section inheritPadding withBorder py="xs">
          <Grid gutter={0}>
            {Array.from({ length: cardActionsRows }).map((_, idx) => {
              // JUST SHOW DIVIDER STYLE IF IS NOT THE LAST ACTION BUTTON (WE CAN ALSO DO THIS WITH CSS last-child)
              return (
                <Grid.Col span={12} key={`${idx}-${cardActionsRows}`}>
                  <Skeleton height={8} mt={6} radius="xl" />
                </Grid.Col>
              );
            })}
          </Grid>
        </Card.Section>
      </Card>
    </>
  );
}
